// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {CSSProperties} from 'react';
import cn from 'classnames';
import styles from './spacer.module.less';
import {Editor} from '../../../shared/editor/editor';

interface i_spacer_props {
    bg_color: string;
    margin: number;
    margin_tablet: number;
    margin_mobile: number;
    unit: string;
}

interface I_spacer_editor_props {
    value: i_spacer_props;
    on_change: (new_value: i_spacer_props)=>void;
}

export const Spacer = (props: i_spacer_props)=>{
    const {bg_color, margin, margin_mobile, margin_tablet, unit} = props;
    const margins = {
        '--spacer_bg_color': bg_color ? bg_color: 'transparent',
        '--margin': margin ? margin+unit: '',
        '--margin_tablet': margin_tablet ? margin_tablet+unit : '',
        '--margin_mobile': margin_mobile ? margin_mobile+unit : '',
        } as CSSProperties;
    return <div style={margins}
      className={cn(styles.spacer, margin_mobile==0 && styles.hidden)}>
        &nbsp;</div>;
};

export const Spacer_editor = (props: I_spacer_editor_props)=>{
    const {value = {bg_color: '', margin: '', margin_tablet: '',
        margin_mobile: '', unit: ''}, on_change} = props;
    type editor_key = keyof i_spacer_props;
    type editor_type = 'text' | 'textarea' | 'number' | 'boolean'
        | 'selector' | 'color';
    const editors = [
        ['bg_color', 'Background color', 'color'],
        ['margin', 'Desktop Spacer Height', 'number'],
        ['margin_tablet', 'Tablet Spacer Height', 'number'],
        ['margin_mobile', 'Mobile Spacer Height', 'number'],
        ['unit', 'Spacer Unit(px/em/rem)', 'text'],
    ].map(([key, label, type])=>({key: key as editor_key, label,
        type: type as editor_type}));
    return <Editor
      value={value}
      editors={editors}
      on_change={on_change}
      title="Spacer"
    />;
};
